<div class="footer">
  <div>
    <strong>Copyright &copy;</strong> {{ getFooterNote() }}, {{ getFullYear() }}. Version: {{ENVIRONMENT.version}}
  </div>
</div>
